/**
 * Client-side form validation and submission for contracting module.
 *
 * @package     Emb_Coverage_Suite
 * @subpackage  Emb_Coverage_Suite/Public/JS
 * @since       0.1.0
 */

(function ($) {
	'use strict';

	/**
	 * Disable submit button.
	 */
	function emb_contracting_submit_disable() {
		jQuery( '.js-contracting-submit' ).attr( 'disabled', 'disabled' );
	}

	/**
	 * Enable submit button.
	 */
	function emb_contracting_submit_enable() {
		jQuery( '.js-contracting-submit' ).removeAttr( 'disabled' );
	}

	/**
	 * Reset form and messages.
	 */
	function emb_contracting_reset() {
		jQuery( '#js-contracting-form' ).trigger( "reset" );
		jQuery( '.js-contracting-message' ).removeClass( 'msg-alert msg-alert--error msg-alert--success' ).empty();
	}

	/**
     * Scroll to first error message
     *
     * @param {number} offset - Offset from top in pixels (default: 250)
     * @param {number} duration - Animation duration in ms (default: 300)
     */
    function emb_contracting_scroll_to_first_error(offset = 250, duration = 300) {
        const firstError = jQuery('.msg-alert--error').first();
        if (firstError.length > 0) {
            jQuery('html, body').animate({
                scrollTop: firstError.offset().top - offset
            }, duration);
        }
    }

	/**
	 * Reset field validation message
	 *
	 * @param {*} fieldName
	 */
    function emb_contracting_reset_field_message(fieldName) {
        const fieldElement = jQuery(`span[data-field="${fieldName}"]`);
        fieldElement.empty()
            .removeClass('msg-alert msg-alert--error msg-alert--success');
    }

    /**
     * Show field validation message
     *
     * @param {string} fieldName - Field identifier
     * @param {string} message - Message to display
     * @param {boolean} isError - True for error, false for success
     */
    function emb_contracting_show_field_message(fieldName, message, isError = true) {
        const fieldElement = jQuery(`span[data-field="${fieldName}"]`);
        fieldElement.empty()
            .removeClass('msg-alert msg-alert--error msg-alert--success')
            .addClass(`msg-alert msg-alert--${isError ? 'error' : 'success'}`)
            .text(message);
    }

	/**
	 * Reset conditions message
	 */
    function emb_contracting_reset_conditions() {
        const fieldElement = jQuery('.js-contracting-promotion-conditions');
        fieldElement.empty()
            .removeClass('msg-alert');
    }

	/**
     * Show conditions message
     *
     * @param {string} message - Message to display
     */
    function emb_contracting_show_conditions(message) {
        const fieldElement = jQuery('.js-contracting-promotion-conditions');
        fieldElement.empty()
            .removeClass('msg-alert')
            .addClass(`msg-alert`)
            .text(message);
    }

    /**
     * Validate a single field
     *
     * @param {jQuery} field - jQuery field element
     * @param {string} fieldName - Field identifier for error display
     * @param {string} errorMessage - Error message to show
     * @param {function} validationFn - Custom validation function (optional)
     * @returns {boolean} True if valid, false otherwise
     */
    function emb_contracting_validate_field(field, fieldName, errorMessage, validationFn = null) {
        const value = field.val().trim();

        // Empty check
        if (value.length === 0) {
            emb_contracting_show_field_message(fieldName, errorMessage, true);
            return false;
        }

        // Custom validation
        if (validationFn && !validationFn(value)) {
            emb_contracting_show_field_message(fieldName, errorMessage, true);
            return false;
        }

        // Success
        emb_contracting_show_field_message(
            fieldName,
            _emb_coverage_suite_contracting_lang.success_input,
            false
        );
        return true;
    }

    /**
     * Validate date format and validity
     *
     * @param {string} dateValue - Date string to validate
     * @returns {boolean} True if valid
     */
    function emb_contracting_validate_date(dateValue) {
        const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
        return dateRegex.test(dateValue) && !isNaN(new Date(dateValue).getTime());
    }

	/**
     * Validate document type selection
     *
     * @param {string} documentTypeValue - Document type value
     * @returns {boolean} True if valid
     */
    function emb_contracting_validate_select(documentTypeValue) {
        return documentTypeValue !== '0' && documentTypeValue !== '';
    }

    /**
     * Validate document format
     *
     * @param {string} documentValue - Document to validate
     * @returns {boolean} True if valid
     */
    function emb_contracting_validate_document(documentValue) {
        // Basic validation: exactly 9 characters
        return documentValue.length === 9;
    }

	/**
     * Validate email format
     *
     * @param {string} emailValue - Email to validate
     * @returns {boolean} True if valid
     */
    function emb_contracting_validate_email(emailValue) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(emailValue);
    }

    /**
     * Validate phone format (Spanish format)
     *
     * @param {string} phoneValue - Phone to validate
     * @returns {boolean} True if valid
     */
    function emb_contracting_validate_phone(phoneValue) {
        // Remove spaces and common separators
        const cleanPhone = phoneValue.replace(/[\s\-\(\)]/g, '');
        // Spanish phone: +34 followed by 9 digits, or just 9 digits
        const phoneRegex = /^(\+34)?[6-9]\d{8}$/;
        return phoneRegex.test(cleanPhone);
    }

	/**
     * Validate IBAN checksum using mod-97 algorithm
     *
     * @param {string} iban - Clean IBAN string (no spaces, uppercase)
     * @returns {boolean} True if checksum is valid
     */
    function emb_contracting_validate_iban_checksum(iban) {
        // Move first 4 characters to the end
        const rearranged = iban.substring(4) + iban.substring(0, 4);

        // Replace letters with numbers (A=10, B=11, ..., Z=35)
        let numericString = '';
        for (let i = 0; i < rearranged.length; i++) {
            const char = rearranged.charAt(i);
            if (char >= 'A' && char <= 'Z') {
                numericString += (char.charCodeAt(0) - 55).toString();
            } else {
                numericString += char;
            }
        }

        // Calculate mod 97
        let remainder = 0;
        for (let i = 0; i < numericString.length; i++) {
            remainder = (remainder * 10 + parseInt(numericString.charAt(i))) % 97;
        }

        return remainder === 1;
    }

	/**
     * Validate IBAN format (Spanish format)
     *
     * @param {string} ibanValue - IBAN to validate
     * @returns {boolean} True if valid
     */
    function emb_contracting_validate_iban(ibanValue) {
        // Remove spaces and convert to uppercase
        const cleanIban = ibanValue.replace(/\s/g, '').toUpperCase();

        // Check Spanish IBAN format: ES + 22 digits
        const spanishIbanRegex = /^ES\d{22}$/;

        if (!spanishIbanRegex.test(cleanIban)) {
            return false;
        }

        // Validate IBAN checksum using mod-97 algorithm
        return emb_contracting_validate_iban_checksum(cleanIban);
    }

	/**
	 * Validate ICC format (10-22 digits)
	 *
	 * @param {string} iccValue - ICC to validate
	 * @returns {boolean} True if valid
	 */
	function emb_contracting_validate_icc(iccValue) {
		const cleanIcc = iccValue.replace(/\s/g, '');
		return /^\d{10,22}$/.test(cleanIcc);
	}

	/**
	 * Validate ZIP code format (5 digits)
	 * @param {string} zipValue - ZIP code to validate
	 * @returns {boolean} True if valid
	 */
	function emb_contracting_validate_zip(zipValue) {
		return /^\d{5}$/.test(zipValue);
	}

	/**
	 * Validate ZIP code format (5 digits)
	 * @param {string} zipValue - ZIP code to validate
	 * @returns {boolean} True if valid
	 */
	function emb_contracting_validate_zip_aragon(zipValue) {
		return /^(50|22|44)\d{3}$/.test(zipValue);
	}

    /**
     * Validate personal data fields.
     *
     * @param {jQuery} name
     * @param {jQuery} firstSurname
     * @param {jQuery} secondSurname
     * @param {jQuery} birthday
     * @param {jQuery} documentType
     * @param {jQuery} document
     *
     * @returns {boolean} True if valid, false if errors
     */
    function emb_contracting_form_personal_validate(
        name,
        firstSurname,
        secondSurname,
        birthday,
        documentType,
        document
    ) {
        let isValid = true;

        // Validate name
        if (!emb_contracting_validate_field(
            name,
            'js-contracting-personal-name',
            _emb_coverage_suite_contracting_lang.error_input_name
        )) {
            isValid = false;
        }

        // Validate first surname
        if (!emb_contracting_validate_field(
            firstSurname,
            'js-contracting-personal-first-surname',
            _emb_coverage_suite_contracting_lang.error_input_first_surname
        )) {
            isValid = false;
        }

        // Validate second surname
        if (!emb_contracting_validate_field(
            secondSurname,
            'js-contracting-personal-second-surname',
            _emb_coverage_suite_contracting_lang.error_input_second_surname
        )) {
            isValid = false;
        }

        // Validate birthday
        if (!emb_contracting_validate_field(
            birthday,
            'js-contracting-personal-birthday',
            _emb_coverage_suite_contracting_lang.error_input_birthday,
            emb_contracting_validate_date
        )) {
            isValid = false;
        }

        // Validate document type
        if (!emb_contracting_validate_field(
            documentType,
            'js-contracting-personal-document-type',
            _emb_coverage_suite_contracting_lang.error_input_document_type,
            emb_contracting_validate_select
        )) {
            isValid = false;
        }

        // Validate document
        if (!emb_contracting_validate_field(
            document,
            'js-contracting-personal-document',
            _emb_coverage_suite_contracting_lang.error_input_document,
            emb_contracting_validate_document
        )) {
            isValid = false;
        }

        // Scroll to first error if validation failed
        if (!isValid) {
            emb_contracting_scroll_to_first_error(250, 0);
        }

        return isValid;
    }

	/**
     * Validate contact data fields.
     *
     * @param {jQuery} email
     * @param {jQuery} mobile
     * @param {jQuery} phone
     * @param {jQuery} contacted
     * @param {jQuery} howFindUs
     *
     * @returns {boolean} True if valid, false if errors
     */
    function emb_contracting_form_contact_validate(
        email,
        mobile,
        phone,
        contacted,
        howFindUs
    ) {
        let isValid = true;

        // Validate email
        if (!emb_contracting_validate_field(
            email,
            'js-contracting-contact-email',
            _emb_coverage_suite_contracting_lang.error_input_email,
            emb_contracting_validate_email
        )) {
            isValid = false;
        }

        // Validate mobile
        if (!emb_contracting_validate_field(
            mobile,
            'js-contracting-contact-mobile',
            _emb_coverage_suite_contracting_lang.error_input_mobile,
            emb_contracting_validate_phone
        )) {
            isValid = false;
        }

        // Validate phone (optional field - only validate if not empty)
        const phoneValue = phone.val().trim();
        if (phoneValue.length > 0) {
            if (!emb_contracting_validate_phone(phoneValue)) {
                emb_contracting_show_field_message(
                    'js-contracting-contact-phone',
                    _emb_coverage_suite_contracting_lang.error_input_phone,
                    true
                );
                isValid = false;
            } else {
                emb_contracting_show_field_message(
                    'js-contracting-contact-phone',
                    _emb_coverage_suite_contracting_lang.success_input,
                    false
                );
            }
        } else {
            // Clear any previous messages if field is empty
            const phoneFieldElement = jQuery('span[data-field="js-contracting-contact-phone"]');
            phoneFieldElement.empty().removeClass('msg-alert msg-alert--error msg-alert--success');
        }

        // Validate contacted preference (optional field)
        if (!emb_contracting_validate_field(
            contacted,
            'js-contracting-contact-contacted',
            _emb_coverage_suite_contracting_lang.error_input_contacted,
            emb_contracting_validate_select
        )) {
            isValid = false;
        }

        // Validate how find us (optional field)
        if (!emb_contracting_validate_field(
            howFindUs,
            'js-contracting-contact-how-find-us',
            _emb_coverage_suite_contracting_lang.error_input_how_find_us,
            emb_contracting_validate_select
        )) {
            isValid = false;
        }

        // Scroll to first error if validation failed
        if (!isValid) {
            emb_contracting_scroll_to_first_error(250, 0);
        }

        return isValid;
    }

	/**
	 * Get line data from the form.
	 *
	 * @param {jQuery} element - jQuery element for the line
	 * @returns {Object} Line data object
	 */
	function emb_contracting_form_get_line(element) {
		const lineData = {};

		element.find('input[type="hidden"], input[type="text"], input[type="radio"]:checked, select').each(function() {
			const item = jQuery(this);
			const name = item.attr('name');
			const value = item.val();

			if (name) {
				lineData[name] = value;
			}
		});

		return lineData;
	}

	/**
	 * Get lines data from the form.
	 *
	 * @returns {Object} Object with landlines and mobile arrays
	 */
	function emb_contracting_form_get_lines() {
		const linesContainer = jQuery('.js-lines-item');
		const linesData = {
			landlines: [],
			mobiles: [],
			additional_lines: []
		};

		linesContainer.each(function() {
			const lineElement = jQuery(this);
			const lineType = lineElement.data('type');

			if (lineType === 'FIJO') {
				linesData.landlines.push(emb_contracting_form_get_line(lineElement));
			} else if (lineType === 'MOV') {
				linesData.mobiles.push(emb_contracting_form_get_line(lineElement));
			} else if (lineType === 'ADDITIONAL') {
				linesData.additional_lines.push(emb_contracting_form_get_line(lineElement));
			}
		});

		return linesData;
	}

	/**
	 * Extract relevant lines data for submission.
	 *
	 * @param {*} lines
	 * @returns {Object} Processed lines data
	 */
	function emb_contracting_form_get_lines_data(lines) {
		const linesData = {
			landlines: [],
			mobiles: [],
			additional_lines: []
		};

		for (let i = 0; i < lines.landlines.length; i++) {
			const line = lines.landlines[i];

			const portabilityKey = Object.keys(line).find(key => key.includes('portability'));
			if (!portabilityKey) {
				continue;
			}
			const lineNumber = portabilityKey.match(/\d+$/)[0];

			const lineData = {
				id: line[`js-contracting-lines-id-${lineNumber}`],
				document: line[`js-contracting-lines-document-${lineNumber}`],
				documentType: line[`js-contracting-lines-document-type-${lineNumber}`],
				name: line[`js-contracting-lines-name-${lineNumber}`],
				firstSurname: line[`js-contracting-lines-first-surname-${lineNumber}`],
				secondSurname: line[`js-contracting-lines-second-surname-${lineNumber}`],
				operator: line[`js-contracting-lines-operator-${lineNumber}`],
				owner: line[`js-contracting-lines-owner-${lineNumber}`],
				phone: line[`js-contracting-lines-phone-${lineNumber}`],
				portability: line[`js-contracting-lines-portability-${lineNumber}`],
			};

			linesData.landlines.push(lineData);
		}

		for (let i = 0; i < lines.mobiles.length; i++) {
			const line = lines.mobiles[i];

			const portabilityKey = Object.keys(line).find(key => key.includes('portability'));
			if (!portabilityKey) {
				continue;
			}
			const lineNumber = portabilityKey.match(/\d+$/)[0];

			const lineData = {
				id: line[`js-contracting-lines-id-${lineNumber}`],
				document: line[`js-contracting-lines-document-${lineNumber}`],
				documentType: line[`js-contracting-lines-document-type-${lineNumber}`],
				name: line[`js-contracting-lines-name-${lineNumber}`],
				firstSurname: line[`js-contracting-lines-first-surname-${lineNumber}`],
				secondSurname: line[`js-contracting-lines-second-surname-${lineNumber}`],
				operator: line[`js-contracting-lines-operator-${lineNumber}`],
				owner: line[`js-contracting-lines-owner-${lineNumber}`],
				phone: line[`js-contracting-lines-phone-${lineNumber}`],
				portability: line[`js-contracting-lines-portability-${lineNumber}`],
				prepaid: line[`js-contracting-lines-prepaid-${lineNumber}`],
				rate: line[`js-contracting-lines-rate-${lineNumber}`],
			};

			linesData.mobiles.push(lineData);
		}

		for (let i = 0; i < lines.additional_lines.length; i++) {
			const line = lines.additional_lines[i];

			const portabilityKey = Object.keys(line).find(key => key.includes('portability'));
			if (!portabilityKey) {
				continue;
			}
			const lineNumber = portabilityKey.match(/\d+$/)[0];

			const lineData = {
				id: line[`js-contracting-lines-id-${lineNumber}`],
				document: line[`js-contracting-lines-document-${lineNumber}`],
				documentType: line[`js-contracting-lines-document-type-${lineNumber}`],
				name: line[`js-contracting-lines-name-${lineNumber}`],
				firstSurname: line[`js-contracting-lines-first-surname-${lineNumber}`],
				secondSurname: line[`js-contracting-lines-second-surname-${lineNumber}`],
				operator: line[`js-contracting-lines-operator-${lineNumber}`],
				owner: line[`js-contracting-lines-owner-${lineNumber}`],
				phone: line[`js-contracting-lines-phone-${lineNumber}`],
				portability: line[`js-contracting-lines-portability-${lineNumber}`],
				prepaid: line[`js-contracting-lines-prepaid-${lineNumber}`],
				rate: line[`js-contracting-lines-rate-${lineNumber}`],
			};

			linesData.additional_lines.push(lineData);
		}

		return linesData;
	}

	/**
	 * Validate lines data fields.
	 *
	 * @param {*} lines
	 * @param {string} type
	 *
	 * @returns {boolean} True if valid, false if errors
	 */
	function emb_contracting_form_lines_common_validate(lines, type = 'landline') {
		let isValid = true;

		for (let i = 0; i < lines.length; i++) {
			const line = lines[i];

			// Extract line number from field name (e.g., "js-contracting-lines-portability-1" -> "1")
			const portabilityKey = Object.keys(line).find(key => key.includes('portability'));
			if (!portabilityKey) {
				continue;
			}
			const lineNumber = portabilityKey.match(/\d+$/)[0];

			// Only validate if portability is selected
			const portabilityType = line[`js-contracting-lines-portability-${lineNumber}`];
			if (portabilityType === 'new') {
				continue;
			}

			// Validate phone field
			const phoneField = `js-contracting-lines-phone-${lineNumber}`;
			if (!emb_contracting_validate_field(
				jQuery(`#${phoneField}`),
				phoneField,
				_emb_coverage_suite_contracting_lang.error_input_phone,
				emb_contracting_validate_phone
			)) {
				isValid = false;
			}

			// Validate operator field
			const operatorField = `js-contracting-lines-operator-${lineNumber}`;
			if (!emb_contracting_validate_field(
				jQuery(`#${operatorField}`),
				operatorField,
				_emb_coverage_suite_contracting_lang.error_input_operator,
				emb_contracting_validate_select
			)) {
				isValid = false;
			}

			// Validate owner data if not owner
			const ownerType = line[`js-contracting-lines-owner-${lineNumber}`];
			if (ownerType === 'yes') {
				continue;
			}

			// Validate document type field
			const docTypeField = `js-contracting-lines-document-type-${lineNumber}`;
			if (!emb_contracting_validate_field(
				jQuery(`#${docTypeField}`),
				docTypeField,
				_emb_coverage_suite_contracting_lang.error_input_document_type,
				emb_contracting_validate_select
			)) {
				isValid = false;
			}

			// Validate document field
			const docField = `js-contracting-lines-document-${lineNumber}`;
			if (!emb_contracting_validate_field(
				jQuery(`#${docField}`),
				docField,
				_emb_coverage_suite_contracting_lang.error_input_document,
				emb_contracting_validate_document
			)) {
				isValid = false;
			}

			// Validate name field
			const nameField = `js-contracting-lines-name-${lineNumber}`;
			if (!emb_contracting_validate_field(
				jQuery(`#${nameField}`),
				nameField,
				_emb_coverage_suite_contracting_lang.error_input_name
			)) {
				isValid = false;
			}

			// Validate first surname field
			const firstSurnameField = `js-contracting-lines-first-surname-${lineNumber}`;
			if (!emb_contracting_validate_field(
				jQuery(`#${firstSurnameField}`),
				firstSurnameField,
				_emb_coverage_suite_contracting_lang.error_input_first_surname
			)) {
				isValid = false;
			}

			// Validate second surname field
			const secondSurnameField = `js-contracting-lines-second-surname-${lineNumber}`;
			if (!emb_contracting_validate_field(
				jQuery(`#${secondSurnameField}`),
				secondSurnameField,
				_emb_coverage_suite_contracting_lang.error_input_second_surname
			)) {
				isValid = false;
			}

			if (type === 'mobile') {
				// Validate ICC if prepaid
				const rateField = line[`js-contracting-lines-rate-${lineNumber}`];
				if (rateField === 'prepaid') {
					const iccField = `js-contracting-lines-prepaid-${lineNumber}`;

					if (!emb_contracting_validate_field(
						jQuery(`#${iccField}`),
						iccField,
						_emb_coverage_suite_contracting_lang.error_input_icc,
						emb_contracting_validate_icc
					)) {
						isValid = false;
					}
				}
			}
		}

		// Scroll to first error if validation failed
        if (!isValid) {
            emb_contracting_scroll_to_first_error(250, 0);
        }

		return isValid;
	}

	/**
	 * Validate lines data fields.
	 *
	 * @param {*} lines
	 *
	 * @returns {boolean} True if valid, false if errors
	 */
	function emb_contracting_form_lines_validate(lines) {
		let isValidLandlines = true;
		let isValidMobile = true;
		let isValidAdditionalLines = true;

		// Validate landlines
		const landlines = lines.landlines;
		isValidLandlines = emb_contracting_form_lines_common_validate(landlines, 'landline');

		// Validate mobile lines
		const mobileLines = lines.mobiles;
		isValidMobile = emb_contracting_form_lines_common_validate(mobileLines, 'mobile');

		// Validate mobile lines
		const additionalLines = lines.additional_lines;
		isValidAdditionalLines = emb_contracting_form_lines_common_validate(additionalLines, 'mobile');

		return isValidLandlines && isValidMobile && isValidAdditionalLines;
	}

	/**
     * Validate billing data fields.
     *
     * @param {jQuery} name
	 * @param {jQuery} firstSurname
	 * @param {jQuery} secondSurname
	 * @param {jQuery} typeStreet
	 * @param {jQuery} address
	 * @param {jQuery} number
	 * @param {jQuery} zip
	 * @param {jQuery} town
	 * @param {jQuery} county
	 * @param {jQuery} documentType
	 * @param {jQuery} document
	 * @param {jQuery} iban
     *
     * @returns {boolean} True if valid, false if errors
     */
    function emb_contracting_form_billing_validate(
        name,
		firstSurname,
		secondSurname,
		typeStreet,
		address,
		number,
		zip,
		town,
		county,
		documentType,
		document,
		iban
    ) {
        let isValid = true;

        // Validate name
        if (!emb_contracting_validate_field(
            name,
            'js-contracting-invoicing-name',
            _emb_coverage_suite_contracting_lang.error_input_name
        )) {
            isValid = false;
        }

		// Validate first surname
        if (!emb_contracting_validate_field(
            firstSurname,
            'js-contracting-invoicing-first-surname',
            _emb_coverage_suite_contracting_lang.error_input_first_surname
        )) {
            isValid = false;
        }

		// Validate second surname
        if (!emb_contracting_validate_field(
            secondSurname,
            'js-contracting-invoicing-second-surname',
            _emb_coverage_suite_contracting_lang.error_input_second_surname
        )) {
            isValid = false;
        }

		// Validate type street
        if (!emb_contracting_validate_field(
            typeStreet,
            'js-contracting-invoicing-address-type-street',
            _emb_coverage_suite_contracting_lang.error_input_type_street,
			emb_contracting_validate_select
        )) {
            isValid = false;
        }

		// Validate address
        if (!emb_contracting_validate_field(
            address,
            'js-contracting-invoicing-address',
            _emb_coverage_suite_contracting_lang.error_input_address
        )) {
            isValid = false;
        }

		// Validate number
        if (!emb_contracting_validate_field(
            number,
            'js-contracting-invoicing-address-number',
            _emb_coverage_suite_contracting_lang.error_input_number
        )) {
            isValid = false;
        }

		// Validate zip
        if (!emb_contracting_validate_field(
            zip,
            'js-contracting-invoicing-address-zip',
            _emb_coverage_suite_contracting_lang.error_input_zip,
			emb_contracting_validate_zip
        )) {
            isValid = false;
        }

		if (!emb_contracting_validate_field(
            zip,
            'js-contracting-invoicing-address-zip',
            _emb_coverage_suite_contracting_lang.error_input_zip_aragon,
			emb_contracting_validate_zip_aragon
        )) {
            isValid = false;
        }

		// Validate town
        if (!emb_contracting_validate_field(
            town,
            'js-contracting-invoicing-address-town',
            _emb_coverage_suite_contracting_lang.error_input_town
        )) {
            isValid = false;
        }

		// Validate county
        if (!emb_contracting_validate_field(
            county,
            'js-contracting-invoicing-address-county',
            _emb_coverage_suite_contracting_lang.error_input_county
        )) {
            isValid = false;
        }

        // Validate document type
        if (!emb_contracting_validate_field(
            documentType,
            'js-contracting-invoicing-document-type',
            _emb_coverage_suite_contracting_lang.error_input_document_type,
            emb_contracting_validate_select
        )) {
            isValid = false;
        }

        // Validate document
        if (!emb_contracting_validate_field(
            document,
            'js-contracting-invoicing-document',
            _emb_coverage_suite_contracting_lang.error_input_document,
            emb_contracting_validate_document
        )) {
            isValid = false;
        }

		// Validate iban
        if (!emb_contracting_validate_field(
            iban,
            'js-contracting-invoicing-iban',
            _emb_coverage_suite_contracting_lang.error_input_iban,
			emb_contracting_validate_iban
        )) {
            isValid = false;
        }

        // Scroll to first error if validation failed
        if (!isValid) {
            emb_contracting_scroll_to_first_error(250, 0);
        }

        return isValid;
    }

	/**
     * Validate security data fields.
     *
     * @param {jQuery} id
	 * @param {jQuery} time
	 * @param {jQuery} nonce
	 * @param {jQuery} contracting
     *
     * @returns {boolean} True if valid, false if errors
     */
    function emb_contracting_form_security_validate(
		id,
        time,
		nonce,
		contracting
    ) {
        let isValid = true;

		// Validate time
        if (0 === id.val().trim().length) {
			emb_contracting_show_field_message(
				'js-contracting-form',
				_emb_coverage_suite_contracting_lang.error_security,
				true
			);
			isValid = false;
		}

        // Validate time
        if (0 === time.val().trim().length) {
			emb_contracting_show_field_message(
				'js-contracting-form',
				_emb_coverage_suite_contracting_lang.error_security,
				true
			);
			isValid = false;
		}

		// Validate nonce
        if (0 === nonce.val().trim().length) {
			emb_contracting_show_field_message(
				'js-contracting-form',
				_emb_coverage_suite_contracting_lang.error_security,
				true
			);
			isValid = false;
		}

        // Validate contracting
        if (0 !== contracting.val().trim().length) {
			emb_contracting_show_field_message(
				'js-contracting-form',
				_emb_coverage_suite_contracting_lang.error_security,
				true
			);
			isValid = false;
		}

        return isValid;
    }

	/**
	 * Get the rate and additional lines data embedded for the dataLayer.
	 *
	 * @returns {Object} Object with `rate` and `additional_lines` keys.
	 */
	function emb_contracting_get_gtm_data() {
		const dataElement = jQuery('#js-emb-contracting-data').text();
		return JSON.parse(dataElement);
	}

	/**
	 * Build the extra services items (TV, device, alarm, energy, platform) for the dataLayer.
	 *
	 * @param {string} brand - Brand of the contracted rate.
	 * @returns {Array} List of items in the GA4 ecommerce item format.
	 */
	function emb_contracting_get_extras_items(brand) {
		const extras = [
			{ id: 'js-contracting-tv', category: 'tv', variant: 'tv', requiresPrice: true },
			{ id: 'js-contracting-devices', category: 'device', variant: 'device' },
			{ id: 'js-contracting-services-security', category: 'alarm', variant: 'alarm' },
			{ id: 'js-contracting-services-energy', category: 'energy', variant: 'energy' },
			{ id: 'js-contracting-platform', category: 'platform', variant: 'platform' },
			{ id: 'js-contracting-sports', category: 'sports', variant: 'sports' }
		];

		const items = [];

		extras.forEach(function(extra) {
			const select = jQuery(`#${extra.id}`);

			if (!select.length) {
				return;
			}

			const option = select.find('option:selected');
			const id = option.val();
			const name = option.attr('data-name');
			const price = parseFloat(option.attr('data-price') || 0);

			if (!id || '0' === id || !name) {
				return;
			}

			// TV can come bundled for free with the rate,
			// so it only counts as its own item when it's an actual paid add-on.
			if (extra.requiresPrice && price <= 0) {
				return;
			}

			items.push({
				item_name: name,
				item_id: id,
				price: price,
				item_brand: brand,
				item_category: extra.category,
				item_category2: '',
				item_category3: '',
				item_category4: '',
				item_variant: extra.variant,
				quantity: 1
			});
		});

		return items;
	}

	/**
	 * Build the full items array for the checkout dataLayer events.
	 *
	 * Includes the contracted rate, its additional lines and any selected extras.
	 *
	 * @returns {Array} List of items in the GA4 ecommerce item format.
	 */
	function emb_contracting_get_checkout_items() {
		const gtmData = emb_contracting_get_gtm_data();
		const rate = gtmData.rate;

		const items = [{
			item_name: rate.name,
			item_id: rate.hub,
			price: rate.price,
			item_brand: rate.brand,
			item_category: rate.category,
			item_category2: rate.category2 || '',
			item_category3: '',
			item_category4: '',
			item_variant: rate.variant,
			quantity: 1
		}];

		(gtmData.additional_lines || []).forEach(function(line) {
			items.push({
				item_name: line.name,
				item_id: line.id,
				price: line.price,
				item_brand: rate.brand,
				item_category: rate.category,
				item_category2: 'additional-line',
				item_category3: '',
				item_category4: '',
				item_variant: 'MOV',
				quantity: line.quantity
			});
		});

		items.push(...emb_contracting_get_extras_items(rate.brand));

		return items;
	}

	/**
	 * Get the current total checkout value.
	 *
	 * @returns {number} Total price displayed in the sticky summary card.
	 */
	function emb_contracting_get_checkout_value() {
		return parseFloat(jQuery('.js-contracting-price').attr('data-price'));
	}

	/**
	 * Send contracting form data via AJAX.
	 *
	 * @param {*} security
	 * @param {*} personal
	 * @param {*} contact
	 * @param {*} lines
	 * @param {*} billing
	 * @param {*} device
	 * @param {*} tv
	 * @param {*} platform
	 * @param {*} sports
	 * @param {*} alarm
	 * @param {*} energy
	 * @param {*} promotion
	 * @param {*} contract
	 * @param {*} price
	 */
	function emb_contracting_form_send(
		security,
		personal,
		contact,
		lines,
		billing,
		device,
		tv,
		platform,
		sports,
		alarm,
		energy,
		promotion,
		contract,
		price
	) {
		let url = '/wp-admin/admin-ajax.php?timestamp=' + new Date().getTime();
		jQuery.ajax({
			type: "POST",
			url: url,
			data: {
				'action': 'emb_form_contracting',
				'data': {
					'security': {
						'id': security.id.val().trim(),
						'time': security.time.val().trim(),
						'nonce': security.nonce.val().trim(),
						'contracting': security.contracting.val().trim(),
					},
					'personal': {
						'name': personal.name.val().trim(),
						'firstSurname': personal.firstSurname.val().trim(),
						'secondSurname': personal.secondSurname.val().trim(),
						'birthday': personal.birthday.val().trim(),
						'documentType': personal.documentType.val().trim(),
						'document': personal.document.val().trim(),
					},
					'contact': {
						'email': contact.email.val().trim(),
						'mobile': contact.mobile.val().trim(),
						'phone': contact.phone.val().trim(),
						'contacted': contact.contacted.val().trim(),
						'howFindUs': contact.howFindUs.val().trim(),
					},
					'lines': lines,
					'billing': {
						'name': billing.name.val().trim(),
						'firstSurname': billing.firstSurname.val().trim(),
						'secondSurname': billing.secondSurname.val().trim(),
						'typeStreet': billing.typeStreet.val().trim(),
						'address': billing.address.val().trim(),
						'number': billing.number.val().trim(),
						'additional': billing.additional.val().trim(),
						'zip': billing.zip.val().trim(),
						'town': billing.town.val().trim(),
						'county': billing.county.val().trim(),
						'documentType': billing.documentType.val().trim(),
						'document': billing.document.val().trim(),
						'iban': billing.iban.val().trim(),
						'observations': billing.observations.val().trim(),
					},
					'device': device && device.length ? device.val().trim() : '',
					'tv': tv && tv.length ? tv.val().trim() : '',
					'platform': platform && platform.length ? platform.val().trim() : '',
					'sports': sports && sports.length ? sports.val().trim() : '',
					'alarm': alarm && alarm.length ? alarm.val().trim() : '',
					'energy': energy && energy.length ? energy.val().trim() : '',
					'promotion': promotion.val().trim(),
					'contract': contract.val().trim(),
					'price': price.attr('data-price').trim(),
				}
			},
			dataType: 'json',
			crossDomain: true,
			cache: false,
			beforeSend: function () {
				emb_contracting_submit_disable();
				emb_contracting_show_field_message(
					'js-contracting-form',
					_emb_coverage_suite_contracting_lang.waiting,
					false
				);
			},
			success: function (data, textStatus, jqXHR) {
				if (200 !== jqXHR.status) {
					emb_contracting_show_field_message(
						'js-contracting-form',
						data.message
					);
					emb_contracting_reset();
					emb_contracting_submit_enable();
					return;
				}

				emb_contracting_show_field_message(
					'js-contracting-form',
					data.message,
					false
				);

				emb_purchase(
					emb_contracting_get_checkout_items(),
					emb_contracting_get_checkout_value(),
					data.response.transaction_id
				);

				setTimeout(function() {
					emb_contracting_reset();
					window.location.href = _emb_coverage_suite_contracting_lang.redirect_url;
				}, 3000);
			},
			error: function (jqXHR) {
				const response = JSON.parse( jqXHR.responseText );
				emb_contracting_show_field_message(
					'js-contracting-form',
					response.message
				);
				emb_contracting_submit_enable();
			}
		});
	}

	/**
     * Form submission handler for contracting.
     */
	function emb_contracting_form() {
		const form = jQuery( '#js-contracting-form' );

		form.on( 'submit', function( e ) {
			e.preventDefault();

			// Get and validate security data fields
            const securityFields = {
				id: jQuery('#js-contracting-id'),
                time: jQuery('#js-contracting-time'),
                nonce: jQuery('#js-contracting-nonce'),
                contracting: jQuery('#js-contracting'),
            };

			const isSecurityValid = emb_contracting_form_security_validate(
				securityFields.id,
				securityFields.time,
				securityFields.nonce,
				securityFields.contracting
			);

			if (!isSecurityValid) {
                return false;
            }

			// Get and validate personal data fields
            const personalFields = {
                name: jQuery('#js-contracting-personal-name'),
                firstSurname: jQuery('#js-contracting-personal-first-surname'),
                secondSurname: jQuery('#js-contracting-personal-second-surname'),
                birthday: jQuery('#js-contracting-personal-birthday'),
                documentType: jQuery('#js-contracting-personal-document-type'),
                document: jQuery('#js-contracting-personal-document')
            };

            const isPersonalValid = emb_contracting_form_personal_validate(
                personalFields.name,
                personalFields.firstSurname,
                personalFields.secondSurname,
                personalFields.birthday,
                personalFields.documentType,
                personalFields.document
            );

			// Get and validate contact data fields
            const contactFields = {
                email: jQuery('#js-contracting-contact-email'),
                mobile: jQuery('#js-contracting-contact-mobile'),
                phone: jQuery('#js-contracting-contact-phone'),
                contacted: jQuery('#js-contracting-contact-contacted'),
                howFindUs: jQuery('#js-contracting-contact-how-find-us')
            };

            const isContactValid = emb_contracting_form_contact_validate(
                contactFields.email,
                contactFields.mobile,
                contactFields.phone,
                contactFields.contacted,
                contactFields.howFindUs
            );

			// Get and validate lines data fields
			const linesFields = emb_contracting_form_get_lines();
			const isLinesValid = emb_contracting_form_lines_validate(linesFields);
			const linesDataFields = emb_contracting_form_get_lines_data(linesFields);

			// Get and validate billing data fields
			const billingFields = {
				name: jQuery('#js-contracting-invoicing-name'),
				firstSurname: jQuery('#js-contracting-invoicing-first-surname'),
				secondSurname: jQuery('#js-contracting-invoicing-second-surname'),
				typeStreet: jQuery('#js-contracting-invoicing-address-type-street'),
				address: jQuery('#js-contracting-invoicing-address'),
				number: jQuery('#js-contracting-invoicing-address-number'),
				additional: jQuery('#js-contracting-invoicing-address-additional'),
				zip: jQuery('#js-contracting-invoicing-address-zip'),
				town: jQuery('#js-contracting-invoicing-address-town'),
				county: jQuery('#js-contracting-invoicing-address-county'),
				documentType: jQuery('#js-contracting-invoicing-document-type'),
				document: jQuery('#js-contracting-invoicing-document'),
				iban: jQuery('#js-contracting-invoicing-iban'),
				observations: jQuery('#js-contracting-invoicing-observations')
			};

			const isBillingValid = emb_contracting_form_billing_validate(
                billingFields.name,
				billingFields.firstSurname,
				billingFields.secondSurname,
				billingFields.typeStreet,
				billingFields.address,
				billingFields.number,
				billingFields.zip,
				billingFields.town,
				billingFields.county,
				billingFields.documentType,
                billingFields.document,
                billingFields.iban
            );

			// If any validation failed, stop submission
			if (!isPersonalValid || !isContactValid || !isLinesValid || !isBillingValid) {
                return false;
            }

			// Get devices fields
			// (No validation needed for device data in this feature)
			const deviceFields = jQuery('#js-contracting-devices');

			// Get tv fields
			// (No validation needed for tv data in this feature)
			const tvFields = jQuery('#js-contracting-tv');

			// Get tv fields
			// (No validation needed for platform data in this feature)
			const platformFields = jQuery('#js-contracting-platform');

			// Get sports fields
			// (No validation needed for sports data in this feature)
			const sportsFields = jQuery('#js-contracting-sports');

			// Get alarm fields
			// (No validation needed for alarm data in this feature)
			const alarmFields = jQuery('#js-contracting-services-security');

			// Get energy fields
			// (No validation needed for energy data in this feature)
			const energyFields = jQuery('#js-contracting-services-energy');

			// Get promotional data field
			// (No validation needed for promo data in this feature)
			const promotionFields = jQuery('#js-contracting-promotion-code');

			// Get contract data fields
			// (No validation needed for contract data in this feature)
			const contractFields = jQuery('#js-contracting-send-contract-option');

			// Get price data
			const price = jQuery('.js-contracting-price');

			// All validations passed, send the form data
			emb_contracting_form_send(
				securityFields,
				personalFields,
				contactFields,
				linesDataFields,
				billingFields,
				deviceFields,
				tvFields,
				platformFields,
				sportsFields,
				alarmFields,
				energyFields,
				promotionFields,
				contractFields,
				price
			);

            return true;
		});
	}

	/**
     * Toggle element visibility
     *
     * @param {jQuery} element - Element to toggle
     * @param {boolean} show - True to show, false to hide
     */
    function emb_contracting_toggle_section(element, show) {
        if (show) {
            element.removeClass('form-item--hidden');
        } else {
            element.addClass('form-item--hidden');
        }
    }

	/**
     * Handle portability section visibility
     *
     * Shows/hides portability fields based on radio button selection.
     */
	function emb_contracting_toggle() {
		const selectors = {
            portabilityNew: '.js-contracting-lines-portability-new',
            portability: '.js-contracting-lines-portability',
            rateContract: '.js-contracting-lines-rate-contract',
            ratePrepaid: '.js-contracting-lines-rate-prepaid',
            yesOwner: '.js-contracting-lines-yes-owner',
            notOwner: '.js-contracting-lines-not-owner'
        };

		// New number selection
		jQuery(document).on('change', selectors.portabilityNew, function() {
            if (!jQuery(this).is(':checked')) return;

            const container = jQuery(this).closest('.box-form__type');
            emb_contracting_toggle_section(container.find('.js-section-portability'), false);
            emb_contracting_toggle_section(container.find('.js-section-prepaid'), false);
            emb_contracting_toggle_section(container.find('.js-section-owner'), false);

			// Reset fields
            container.find(selectors.rateContract).prop('checked', true);
            container.find(selectors.yesOwner).prop('checked', true);
			container.find(".js-contracting-lines-phone").val('');
			container.find(".js-contracting-lines-operator").val(0);
			container.find(".js-section-prepaid").find('.js-contracting-lines-prepaid').val('');
			container.find(".js-section-owner").find('.js-contracting-lines-document-type').val(0);
			container.find(".js-section-owner").find('.js-contracting-lines-document').val('');
			container.find(".js-section-owner").find('.js-contracting-lines-name').val('');
			container.find(".js-section-owner").find('.js-contracting-lines-first-surname').val('');
			container.find(".js-section-owner").find('.js-contracting-lines-second-surname').val('');

			// Clear messages
			container.find(".js-section-portability").find('.js-contracting-message')
				.removeClass('msg-alert msg-alert--error msg-alert--success')
				.empty();
			container.find(".js-section-prepaid").find('.js-contracting-message')
				.removeClass('msg-alert msg-alert--error msg-alert--success')
				.empty();
			container.find(".js-section-owner").find('.js-contracting-message')
				.removeClass('msg-alert msg-alert--error msg-alert--success')
				.empty();
        });

		// Portability selection
		jQuery(document).on('change', selectors.portability, function() {
            if (!jQuery(this).is(':checked')) return;

            const container = jQuery(this).closest('.box-form__type');
            emb_contracting_toggle_section(container.find('.js-section-portability'), true);
        });

		// Contract rate selection
        jQuery(document).on('change', selectors.rateContract, function() {
            if (!jQuery(this).is(':checked')) return;

            const container = jQuery(this).closest('.box-form__type');
            emb_contracting_toggle_section(container.find('.js-section-prepaid'), false);

			// Reset fields
			container.find(".js-section-prepaid").find('.js-contracting-lines-prepaid').val('');

			// Clear messages
			container.find(".js-section-prepaid").find('.js-contracting-message')
				.removeClass('msg-alert msg-alert--error msg-alert--success')
				.empty();
        });

		// Prepaid rate selection
        jQuery(document).on('change', selectors.ratePrepaid, function() {
            if (!jQuery(this).is(':checked')) return;

            const container = jQuery(this).closest('.box-form__type');
            emb_contracting_toggle_section(container.find('.js-section-prepaid'), true);
        });

		// Owner selection
        jQuery(document).on('change', selectors.yesOwner, function() {
            if (!jQuery(this).is(':checked')) return;

            const container = jQuery(this).closest('.box-form__type');
            emb_contracting_toggle_section(container.find('.js-section-owner'), false);

			// Reset fields
			container.find(".js-section-owner").find('.js-contracting-lines-document-type').val(0);
			container.find(".js-section-owner").find('.js-contracting-lines-document').val('');
			container.find(".js-section-owner").find('.js-contracting-lines-name').val('');
			container.find(".js-section-owner").find('.js-contracting-lines-first-surname').val('');
			container.find(".js-section-owner").find('.js-contracting-lines-second-surname').val('');

			// Clear messages
			container.find(".js-section-owner").find('.js-contracting-message')
				.removeClass('msg-alert msg-alert--error msg-alert--success')
				.empty();
        });

		// Not owner selection
        jQuery(document).on('change', selectors.notOwner, function() {
            if (!jQuery(this).is(':checked')) return;

            const container = jQuery(this).closest('.box-form__type');
            emb_contracting_toggle_section(container.find('.js-section-owner'), true);
        });
	}

	/**
	 * Control conditions message based on selected devices.
	 */
	function emb_contracting_control_conditions() {
		jQuery(".js-contracting-conditions-trigger").on("change", function() {
			const id = jQuery(this).attr('id');
			const message = jQuery(`span[data-field="${id}"]`);
			const selectedOption = jQuery(this).find("option:selected");

			if (!selectedOption.length) {
				message.empty().removeClass('msg-alert msg-alert--error msg-alert--success');
				return;
			}

			const conditions = selectedOption.data("conditions");
			const description = selectedOption.data("description");
			let text = '';

			if (conditions && conditions.length > 0) {
				text = conditions;
			} else if (description && description.length > 0) {
				text = description;
			}

			if (text && text.length > 0) {
				message.addClass('msg-alert').text(text);
			} else {
				message.removeClass('msg-alert msg-alert--error msg-alert--success').empty();
			}
		});
	}

	/**
	 * Get service label based on select ID
	 *
	 * @param {string} selectId - The ID of the select element
	 * @returns {string} The label for the service type
	 */
	function emb_contracting_get_service_label(selectId) {
		const labels = {
			'js-contracting-devices': 'DISPOSITIVO',
			'js-contracting-services-security': 'ALARMA',
			'js-contracting-services-energy': 'ENERGÍA'
		};

		return labels[selectId] || 'SERVICIO';
	}

	/**
	 * Update services list in sidebar
	 *
	 * Adds/removes services from the sidebar list based on selected options.
	 */
	function emb_contracting_update_services_list() {
		jQuery(document).on("change", ".js-contracting-name-trigger", function() {
			const selectElement = jQuery(this);
			const selectId = selectElement.attr('id');
			const selectedOption = selectElement.find('option:selected');
			const serviceName = selectedOption.attr('data-name');
			const listItemId = `js-service-${selectId}`;

			// Remove existing list item for this select
			jQuery(`.js-contracting-services-list li[data-id="${listItemId}"]`).remove();

			// Add new list item if a service is selected (not empty and not value "0")
			if (serviceName && serviceName.trim() !== '' && selectedOption.val() !== '0') {
				const serviceLabel = emb_contracting_get_service_label(selectId);
				const listItem = jQuery('<li>')
					.attr('data-id', listItemId)
					.text(`${serviceLabel}: `)
					.append(
						jQuery('<span>').text(serviceName)
					);
				jQuery('.js-contracting-services-list').append(listItem);
			}
		});
	}

	/**
	 * Update price display elements
	 *
	 * @param {number} price - Price to display
	 */
	function emb_contracting_update_price_display(price) {
		const priceParts = price.toFixed(2).split('.');
		const priceInteger = priceParts[0];
		const priceDecimal = priceParts[1] || '00';

		// Update integer part
		jQuery('.js-contracting-price .prix span').text(priceInteger);

		// Update decimal part
		jQuery('.js-contracting-price .prix-2 strong').text(`,${priceDecimal}`);
	}

	/**
	 * Calculate total price from all triggers
	 *
	 * @returns {number} Total calculated price
	 */
	function emb_contracting_calculate_total_price() {
		const basePriceElement = jQuery(".js-contracting-price");
		const basePrice = parseFloat(basePriceElement.attr("data-base-price"));

		let totalPrice = basePrice;

		// Iterate through all price triggers to calculate total
		jQuery(".js-contracting-price-trigger").each(function() {
			const selectedOption = jQuery(this).find("option:selected");
			const priceModifier = selectedOption.attr("data-price");

			if (priceModifier && priceModifier !== "0") {
				totalPrice += parseFloat(priceModifier);
			}
		});

		return totalPrice;
	}

	/**
	 * Initialize base price on page load
	 */
	function emb_contracting_initialize_base_price() {
		const basePriceElement = jQuery(".js-contracting-price");
		const currentPrice = basePriceElement.attr("data-price");

		// Store original base price if not already stored
		if (!basePriceElement.attr("data-base-price")) {
			basePriceElement.attr("data-base-price", currentPrice);
		}
	}

	/**
	 * Control price display based on selected options.
	 */
	function emb_contracting_control_price() {
		// Initialize base price
		emb_contracting_initialize_base_price();

		// Attach change event to all price triggers
		jQuery(document).on("change", ".js-contracting-price-trigger", function() {
			const totalPrice = emb_contracting_calculate_total_price();

			// Update displayed price
			emb_contracting_update_price_display(totalPrice);

			// Update current price data attribute
			jQuery(".js-contracting-price").attr("data-price", totalPrice.toFixed(2));
		});

		// Calculate initial price on page load (in case of pre-selected options)
		const initialPrice = emb_contracting_calculate_total_price();
		emb_contracting_update_price_display(initialPrice);
		jQuery(".js-contracting-price").attr("data-price", initialPrice.toFixed(2));
	}

	/**
	 * Control promotion code validation.
	 */
	function emb_contracting_control_promotion_code() {
		jQuery(document).on("click", ".js-contracting-promotion-code-validate", function() {
			emb_contracting_reset_field_message('js-contracting-promotion-code');
			emb_contracting_reset_conditions();

			const promoCode = jQuery("#js-contracting-promotion-code").val().trim();
			if (promoCode.length <= 3) {
				return;
			}

			const url = '/wp-admin/admin-ajax.php?timestamp=' + new Date().getTime();
			jQuery.ajax({
				type: "POST",
				url: url,
				data: {
					'action': 'emb_form_contracting_promotion',
					'data': {
						'promotion': promoCode,
					}
				},
				dataType: 'json',
				crossDomain: true,
				cache: false,
				success: function (data, textStatus, jqXHR) {
					if (200 !== jqXHR.status) {
						emb_contracting_show_field_message(
							'js-contracting-promotion-code',
							_emb_coverage_suite_contracting_lang.promo_code_invalid,
							true
						);
						return;
					}

					emb_contracting_show_field_message(
						'js-contracting-promotion-code',
						_emb_coverage_suite_contracting_lang.promo_code_valid,
						false
					);

					const { conditions } = data.response;
					emb_contracting_show_conditions(conditions);
				},
				error: function () {
					emb_contracting_show_field_message(
						'js-contracting-promotion-code',
						_emb_coverage_suite_contracting_lang.promo_code_invalid,
						true
					);
				}
			});
		});
	}

	/**
	 * Push the begin_checkout event once, on page load.
	 */
	function emb_contracting_track_begin_checkout() {
		emb_begin_checkout(emb_contracting_get_checkout_items(), emb_contracting_get_checkout_value());
	}

	/**
	 * Push the add_shipping_info event the first time the user interacts with the contact fields.
	 */
	function emb_contracting_track_shipping_info() {
		let hasTracked = false;

		jQuery(
			'#js-contracting-contact-email, #js-contracting-contact-mobile, ' +
			'#js-contracting-contact-phone, #js-contracting-contact-contacted, ' +
			'#js-contracting-contact-how-find-us'
		).on('input change', function() {
			if (hasTracked) {
				return;
			}

			hasTracked = true;
			emb_add_shipping_info(emb_contracting_get_checkout_items(), emb_contracting_get_checkout_value());
		});
	}

	/**
	 * Push the add_payment_info event the first time the user interacts with the billing fields.
	 */
	function emb_contracting_track_payment_info() {
		let hasTracked = false;

		jQuery(
			'#js-contracting-invoicing-address-type-street, #js-contracting-invoicing-address, ' +
			'#js-contracting-invoicing-address-number, #js-contracting-invoicing-address-additional, ' +
			'#js-contracting-invoicing-address-zip, #js-contracting-invoicing-address-town, ' +
			'#js-contracting-invoicing-address-county, #js-contracting-invoicing-name, ' +
			'#js-contracting-invoicing-first-surname, #js-contracting-invoicing-second-surname, ' +
			'#js-contracting-invoicing-document-type, #js-contracting-invoicing-document, ' +
			'#js-contracting-invoicing-iban, #js-contracting-invoicing-observations'
		).on('input change', function() {
			if (hasTracked) {
				return;
			}

			hasTracked = true;
			emb_add_payment_info(emb_contracting_get_checkout_items(), emb_contracting_get_checkout_value());
		});
	}

	/**
	 * Initialize contracting form functionality.
	 */
	function emb_contracting_init() {
		emb_contracting_toggle();
		emb_contracting_control_conditions();
		emb_contracting_control_price();
		emb_contracting_control_promotion_code();
		emb_contracting_update_services_list();
		emb_contracting_form();
		emb_contracting_track_begin_checkout();
		emb_contracting_track_shipping_info();
		emb_contracting_track_payment_info();
	}

	$(function() {
		emb_contracting_init();
    });
})(jQuery);
